import {useContext} from "react"
import { CreateAdminContext } from "./context"

export function useCreateAdminHook() {
    return useContext(CreateAdminContext);
}